import { render, staticRenderFns } from "./ZzpDocuments.vue?vue&type=template&id=60cdc362&scoped=true&"
import script from "./ZzpDocuments.vue?vue&type=script&lang=js&"
export * from "./ZzpDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ZzpDocuments.vue?vue&type=style&index=0&id=60cdc362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cdc362",
  null
  
)

export default component.exports